import React from "react";
import KaDialog from "../shared/KaDialog";
import Img from "../../assets/56.jpg";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import useScreensize from "../../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
  imgBackground: {
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat"
  },
  imgTag: {
    width: "100%",
    height: "auto",
    display: "block"
  },
  paragraph: {
    margin: theme.spacing(3, 0)
  }
}));

const SpektrumSteuerberatung = ({ open, close }) => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl } = useScreensize();
  const theme = useTheme();

  const mobile = xs || sm;

  return (
    <>
      <KaDialog open={open} close={close}>
        <>
          <Box
            display="flex"
            flexDirection={mobile ? "column" : "row"}
            p={{ sm: 3, md: 3 }}
            height={mobile ? undefined : 700}
          >
            {mobile && (
              <Box
                bgcolor={theme.palette.primary.light}
                mb={3}
              >
                <img src={Img} alt="Steuerberatung" className={classes.imgTag} />
              </Box>
            )}
            <Box
              color="white"
              p={{ xs: 3, sm: 4 }}
              mr={mobile ? 0 : 3}
              flexGrow={1}
              bgcolor={theme.palette.primary.main}
              flexShrink={1}
              flexBasis={mobile ? "auto" : "0px"}
            >
              <Typography variant="h1" component="h2">
                Steuerberatung
              </Typography>
              <Typography variant="h6" component="h3" gutterBottom>
                Tradition & Zukunft
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Wir beraten Mandanten von Einzelpersonen bis zu
                mittelständischen Unternehmen.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Sie alle vereint der Anspruch auf ein Maximum an individueller
                Beratung.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Unsere Kanzlei im Herzen von Kaiserslautern ist gleichermaßen
                Ansprechpartner für die Unternehmen der digitalen Zukunft als
                auch für traditionsreiche Handwerksbetriebe.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Nicht zuletzt durch unseren Sitz in der Kreishandwerkerschaft
                haben wir auch räumlich die notwendige Nähe zu unseren
                Mandanten.
              </Typography>
            </Box>
            {!mobile && (
              <Box
                p={3}
                className={classes.imgBackground}
                style={{ backgroundImage: "url(" + Img + ")" }}
                flexGrow={1}
                bgcolor={theme.palette.primary.light}
                flexShrink={1}
                flexBasis="0px"
              ></Box>
            )}
          </Box>
        </>
      </KaDialog>
    </>
  );
};

export default SpektrumSteuerberatung;
